import styled from "styled-components";

export const Test = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible", "isHeaderVisible"].includes(prop),
})<{}>`
  height: 100vh;
  display: block;
  z-index: 10000;
  background: ${({ theme }) => theme.colors.white};
  padding: 0;
  flex-direction: row;
  width: 100%;
  left: 0;
`;

export const FilterModalWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible", "isHeaderVisible"].includes(prop),
})<{ isVisible: boolean; isHeaderVisible: boolean }>`
  height: ${({ theme, isVisible }) => (isVisible ? "100vh" : theme.spacing(7))};
  display: ${({ isVisible }) => (isVisible ? "block" : "flex")};
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGray};
  position: ${({ isVisible }) => (isVisible ? "fixed" : "inherit")};
  z-index: ${({ isVisible }) => (isVisible ? 10 : 0)};
  background: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.white : "none"};
  padding: ${({ theme, isVisible }) =>
    isVisible ? "0" : `0 ${theme.spacing(2)}`};
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  width: 100%;
  top: ${({ isHeaderVisible }) => (isHeaderVisible ? "58px" : "0")};
  left: 0;
`;

export const FilterModalHeaderMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  background-color: ${({ theme, isVisible }) =>
    isVisible ? theme.colors.vividBlue : "transparent"};
  padding: ${({ theme, isVisible }) =>
    isVisible ? `${theme.spacing(2)} 0` : 0};
  flex-direction: ${({ isVisible }) => (isVisible ? "column" : "row")};
  height: fit-content;
  width: 100%;

  & > div {
    height: ${({ isVisible }) => (isVisible ? "auto" : "inherit")};
    align-items: center;
    display: flex;
  }

  & > button {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
    margin-left: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(2) : 0};
  }

  & > svg {
    display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  }

  & svg {
    color: ${({ theme }) => theme.colors.white};
  }

  & input {
    background-color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.transparent : "inherit"};
    color: ${({ theme, isVisible }) =>
      isVisible ? theme.colors.white : theme.colors.darkGray};
    font-size: ${({ theme, isVisible }) =>
      isVisible ? theme.fontSizes.md : "inherit"};
    height: ${({ theme, isVisible }) =>
      isVisible ? theme.spacing(6) : "inherit"};
    width: 100%;

    &::placeholder {
      color: ${({ theme, isVisible }) =>
        isVisible ? theme.colors.white : theme.colors.darkGray};
    }
  }
`;

export const FieldSearchMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isVisible"].includes(prop),
})<{ isVisible: boolean }>`
  height: ${({ isVisible }) => (isVisible ? "auto" : "inherit")};
  padding: ${({ theme }) =>
    (isVisible) =>
      isVisible ? `0` : `${theme.spacing(2)} 0`};
  /* gap: ${({ theme }) => theme.spacing(2)}; */
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  & > svg {
    height: ${({ theme }) => theme.spacing(3.2)};
    width: ${({ theme }) => theme.spacing(5.5)};
  }
`;

export const FieldSearchDropdownMobile = styled.div.withConfig({
  shouldForwardProp: (prop) => !["type"].includes(prop),
})<{ type: string }>`
  padding-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;
export const FilterModalModalHeader = styled.div.withConfig({})`
  display: flex;
  height: 70px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  margin-top: 10px;
  z-index: 10;
`;

export const FilterModalModalContent = styled.div.withConfig({})`
  display: flex;
  height: 77vh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 10;
  justify-content: center;
  padding-top: 15px;
  padding-left: 10px;
  padding-right: 10px;
  overflow-y: scroll;
`;

export const FilterModalModalFooter = styled.div.withConfig({})`
  display: flex;
  height: 13vh;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 10;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  /* border: 1px solid ${({ theme }) => theme.colors.gray}; */
  border-bottom: none;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

export const IconContent = styled.div.withConfig({})`
  display: flex;
  height: 100%;
  width: 10%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  z-index: 10;
  justify-content: center;
  padding-top: 10px;
`;

export const InfoContent = styled.div.withConfig({})`
  display: flex;
  height: 100%;
  width: 90%;
  background-color: ${({ theme }) => theme.colors.vividBlue};
  z-index: 10;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 10px;
`;

// styles.ts
export const DivFooterModalBackground = styled.div`
  position: fixed; /* gruda na viewport, não no pai */
  inset: 0; /* top/right/bottom/left = 0 */
  width: 100vw;
  height: 100dvh; /* evita o bug de 100vh no iOS */
  display: flex;
  flex-direction: column;
  z-index: 9999; /* acima de headers/stickies */
  background: rgba(0, 0, 0, 0.5);
  overscroll-behavior: contain; /* evita “vazar” scroll pro body */
`;

export const DivFooterModal = styled.div`
  display: flex;
  background-color: #fefefe;
  border: 1px solid #888;
  width: 100%;
  min-height: 100%;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  flex-direction: column;
`;
